<template>
    <div :class="{ invert: props.invert }">
        <Icon :icon="props.icon" :sprite="props.sprite" v-if="props.icon" />

        <span v-if="props.title" v-html="props.title"></span>
        <span v-if="props.description" class="description" v-html="props.description"></span>
    </div>
</template>

<script setup>
const props = defineProps({
    icon: { type: String, default: '' },
    sprite: { type: String, default: '' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    invert: { type: Boolean, default: false }
});
</script>

<style lang="scss" scoped>
div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;
    gap: 12px;

    & > video,
    & > svg {
        width: 52px;
        height: 52px;
        margin-bottom: 24px;
        fill: var(--dark-80);
        stroke: var(--dark-20);
    }

    & > span {
        font: var(--font-body-1);
        font-weight: bold;
        color: var(--dark-80);
        text-align: center;

        &.description {
            font: var(--font-body-2);
            color: var(--gray-500);
            text-align: center;
            padding: 0 10px;
        }
    }

    &.invert {
        & > span {
            color: var(--white-80);
        }
    }

    /* Анимации */
    .anim-bounce {
        animation: bounce 2.4s infinite;
    }

    @keyframes bounce {
        0% { transform: scale(1); }
        50% { transform: scale(1.25); }
        100% { transform: scale(1); }
    }

    .anim-rotate {
        animation: rotate 1.6s infinite;
    }

    @keyframes rotate {
        0% { transform: rotate(0); }
        60% { transform: rotate(20deg); }
        100% { transform: rotate(0); }
    }

    .anim-pulse {
        animation: pulse 2.8s infinite;
    }

    @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.15); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
    }

    .anim-pop {
        animation: pop 2s infinite;
    }

    @keyframes pop {
        0% { transform: scale(0.9); }
        70% { transform: scale(1.3); }
        100% { transform: scale(1); }
    }

    .anim-wiggle {
        animation: wiggle 1s infinite;
    }

    @keyframes wiggle {
        0% { transform: rotate(0); }
        25% { transform: rotate(-8deg); }
        50% { transform: rotate(8deg); }
        75% { transform: rotate(-4deg); }
        100% { transform: rotate(0); }
    }
}
</style>
